/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseEntryStatisticViewRecord } from './DatabaseEntryStatisticViewRecord';
import {
    DatabaseEntryStatisticViewRecordFromJSON,
    DatabaseEntryStatisticViewRecordFromJSONTyped,
    DatabaseEntryStatisticViewRecordToJSON,
} from './DatabaseEntryStatisticViewRecord';

/**
 * 
 * @export
 * @interface DatabaseEntryStatistic
 */
export interface DatabaseEntryStatistic {
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseEntryStatistic
     */
    viewed?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DatabaseEntryStatistic
     */
    viewCount?: number;
    /**
     * 
     * @type {Array<DatabaseEntryStatisticViewRecord>}
     * @memberof DatabaseEntryStatistic
     */
    views?: Array<DatabaseEntryStatisticViewRecord>;
}

/**
 * Check if a given object implements the DatabaseEntryStatistic interface.
 */
export function instanceOfDatabaseEntryStatistic(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseEntryStatisticFromJSON(json: any): DatabaseEntryStatistic {
    return DatabaseEntryStatisticFromJSONTyped(json, false);
}

export function DatabaseEntryStatisticFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseEntryStatistic {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'viewed': !exists(json, 'viewed') ? undefined : json['viewed'],
        'viewCount': !exists(json, 'viewCount') ? undefined : json['viewCount'],
        'views': !exists(json, 'views') ? undefined : ((json['views'] as Array<any>).map(DatabaseEntryStatisticViewRecordFromJSON)),
    };
}

export function DatabaseEntryStatisticToJSON(value?: DatabaseEntryStatistic | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'viewed': value.viewed,
        'viewCount': value.viewCount,
        'views': value.views === undefined ? undefined : ((value.views as Array<any>).map(DatabaseEntryStatisticViewRecordToJSON)),
    };
}

